module.exports = __webpack_public_path__ + "b984b8df4a33021a5207598a90e61720.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ogs-logo.png
// module id = 519
// module chunks = 0